import { ClusterSection } from "@app/components/ClusterSection.tsx";
import { getDocsByCluster } from "@app/lib/manifest.ts";
import { navigateTo } from "@app/lib/router.ts";
import type { DocEntry, Manifest } from "@manifest/schema.ts";

const CLUSTER_ORDER = [
  "About",
  "Cell Model",
  "Protocols",
  "Wallets/Auth",
  "Tooling/Standards",
] as const;

interface ListProps {
  manifest: Manifest;
  onOpenSearch: () => void;
}

export function List({ manifest, onOpenSearch }: ListProps) {
  const grouped = getDocsByCluster(manifest);
  const handleSelect = (doc: DocEntry): void => {
    navigateTo({ kind: "doc", id: doc.id });
  };

  return (
    <main className="max-w-4xl mx-auto px-6 py-16">
      <header className="mb-16 text-center">
        <img src="/brand/logo-256.png" alt="" width="88" height="88" className="mx-auto mb-6" />
        <h1 className="font-serif text-5xl font-bold tracking-tight text-parchment-900 mb-4">
          cklibrary
        </h1>
        <p className="text-parchment-700 max-w-xl mx-auto leading-relaxed">
          {manifest.docs.length} canonical Nervos protocol documents minted as CKBFS cells on chain.
          Browse by cluster
          <span className="hidden sm:inline">
            , or press{" "}
            <kbd className="px-2 py-0.5 bg-parchment-200 border border-parchment-400 rounded text-xs font-mono">
              ⌘K
            </kbd>{" "}
            to search
          </span>
          .
        </p>
        <button
          type="button"
          onClick={onOpenSearch}
          className="sm:hidden mt-6 w-full flex items-center gap-2 px-4 py-3 bg-parchment-50 border border-parchment-400 rounded-md text-left text-parchment-600 font-mono text-sm hover:bg-parchment-100 transition-colors"
        >
          <span aria-hidden="true">🔍</span>
          <span>search documents…</span>
        </button>
        <div className="mt-6 flex items-center justify-center gap-2">
          <span className="h-px w-12 bg-parchment-400" aria-hidden="true" />
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-parchment-600">
            cklibrary catalogue
          </span>
          <span className="h-px w-12 bg-parchment-400" aria-hidden="true" />
        </div>
      </header>
      {CLUSTER_ORDER.filter((c) => grouped[c]).map((cluster) => (
        <ClusterSection
          key={cluster}
          cluster={cluster}
          docs={grouped[cluster] ?? []}
          onSelect={handleSelect}
        />
      ))}
    </main>
  );
}
